/**
 * Gets the laravel dot notation errors as object.
 *
 */
export default function (errors, firstGlue = " ", secondGlue = ", ") {
    let obj = {};
    for (let [key, value] of Object.entries(errors)) {
        obj[key] = value.join(secondGlue);
    }

    let str = "";
    for (let [key, value] of Object.entries(obj)) {
        str = str + (str === "" ? value : firstGlue + value);
    }
    return str;
};
